import { createStudent } from './'
import { db } from '../../../config/firebaseconfig'
import { licenseAllUsers } from './'

/**
 * Creates all students who have records in the upload
 * data who do not already exist in the database.
 * @param {array} uploadData The parsed array of row objects from the csv upload
 * @param {object} school The school object
 * @param {string} schoolYear The active school year ('2018' for 2018-19, for example)
 * @returns {array} the ids of the created students
 */
export default function createStudents (uploadData, school, schoolYear, assessmentId, assessment) {
  // fetch all of the classes and teacher sin the school
  const fetchClasses = db.collection('classes').where('school', '==', school.id).get()
  const fetchTeachers = db.collection('educators').where('school', '==', school.id).get()
  return Promise.all([fetchClasses, fetchTeachers])
    .then(results => {
      // parse the results into classes and teachers objects
      const [ classesResults, teachersResults ] = results 
      let classes = {}, teachers = {}
      classesResults.forEach(doc => {
        if (doc.exists) classes[doc.id] = doc.data()
      })
      teachersResults.forEach(doc => {
        if (doc.exists) {
          const data = doc.data()
          const ident = data.email || data.username
          teachers[ident] = data
        }
      })

      // call createStudent for each student record
      let createStudentPromises = []
      uploadData.forEach(record => {
        createStudentPromises.push(createStudent(record, school, schoolYear, classes, teachers))
      })
      return Promise.all(createStudentPromises)
    })
    .then(students => {
      const createdStudents = students.filter(student => student.data).map(student => student.data)
      const finalOutput = students.filter(student => student.data || student.error)
      return Promise.all([
        licenseAllUsers(createdStudents, school, assessmentId, assessment, 'student'),
        finalOutput
      ])
    })
    .then(results => {
      const [licenseReturn, finalOutput] = results
      return finalOutput
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/createStudents.js